import Layout from "global/component/Genericos/Layout/Layout";
import { GlobalContext } from "global/context/Provider";
import camelize from "global/utils/camelize";
import { useContext, useEffect, useState } from "react";
import LogoDim from "_+_Portal/assets/images/generico/LogoDim";
import MiTurnoIcon from "_+_Portal/assets/images/generico/MiTurnoIcon";
import { OtrosTramites } from "_+_Portal/assets/images/generico/OtrosTramites";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { LimpiarSelectGlobal } from "_+_Portal/context/Actions/DropDownFamiliares/selectFamiliares";
import { hideModal, showModal } from "_+_Portal/context/Actions/modal/modal";
import { PortalContext } from "_+_Portal/context/Provider";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import {
  wsGetTurnosConPresenteQr,
  wsGetTurnosPacienteDelDiaQr,
} from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import { setTurnosRecepcionadosAll } from "_+_Portal/_-_Autocheckin/context/action/turnosRecepcionados";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import TildeOk from "../../../assets/images/generico/TildeOk";
import { BtnContainer, ContianerHome, HeaderHomeBar } from "./localStyle";
import { setAvisoAutocheck } from "_+_Portal/_-_Autocheckin/context/action/avisoAutocheck";
import { OrderTurnosLabo } from "../PagesFun";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { useHistory } from "react-router";
import { FaMapMarkerAlt } from "react-icons/fa";
import { motion } from "framer-motion";
import { containerVariants, itemVariants } from "global/utils/btnTransition";
import { wsGetOrdenesDigitalesById } from "_+_Portal/_-_Autocheckin/context/action/ordenesDigitales";
import { showToaster } from "global/context/action/toaster/toaster";
import { wsGetLabOrdenDigital } from "_+_Portal/context/Actions/labOrdenDigital/labOrdenDigital";
import OrdenesDigitalesIcon from "_+_Portal/assets/images/generico/OrdenesDigitalesIcon";

const Home = ({ setLoading, setPasoSelectFamiliar }) => {
  // -------------------------  context ----------------------------
  const {
    pasoDispatch,
    turnosAutoCheckInDispatch,
    turnosRecepcionadosDispatch,
    turnosSeleccionadosDispatch,
    avisoAutocheckState,
    avisoAutocheckDispatch,
    textosAutoCheckinState,
    puntoControlDispatch,
  } = useContext(AutocheckContext);
  const { authState, toasterDispatch } = useContext(GlobalContext);
  const {
    modalDispatch,
    selectDropDownState,
    selectDropDownDispatch,
    labOrdenDigitalDispatch,
  } = useContext(PortalContext);

  // -------------------------  context ----------------------------

  // -------------------------  useStates ----------------------------
  const [dataLoading, setDataLoading] = useState(true);
  const [ordenesLoading, setOrdenesLoading] = useState(true);
  const [nextStepTo, setNextStepTo] = useState(true);
  const [btnGreen, setBtnGreen] = useState(false);
  // -------------------------  useStates ----------------------------

  // -------------------------  constantes ----------------------------
  const pacienteNombre = authState?.auth?.data?.paciente?.nombre;
  const idPacFamiliar = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.codigo
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.codigo
    : false;
  let config = localStorage.getItem("config");
  let opcAutoCheckInLabo = JSON.parse(config).opcAutoCheckInLabo;
  let portal = JSON.parse(config).portal;

  const filtroHorario =
    textosAutoCheckinState.textosAutoCheckin?.data?.filtroHorario?.orden;
  const minutosToleranciaRecepcion =
    JSON.parse(config)?.minutosToleranciaRecepcion;
  const minRecepcionVariosTurnos = JSON.parse(config)?.minRecepcionVariosTurnos;
  const autorizado = sessionStorage.getItem("claveVerificada");
  const noAsociar = sessionStorage.getItem("dismissOrden");
  const history = useHistory();
  // -------------------------  constantes ----------------------------

  // -------------------------  funciones ----------------------------

  const nextStepTurnosPacienteDelDia = (isCorrect, turnosList) => {
    if (isCorrect) {
      if (opcAutoCheckInLabo) {
        setNextStepTo("SelectorCircuito");
      } else {
        setNextStepTo("TurnosDelDia");
      }
    } else {
      setNextStepTo("SelectorCircuito");
    }
    setDataLoading(false);
  };

  const nextStepTurnosConPresente = (isCorrect, data) => {
    if (isCorrect && data) {
      setTurnosSeleccionado([])(turnosSeleccionadosDispatch);
      setNextStepTo("TurnosRecepionados");
      setBtnGreen(true);
      setDataLoading(false);
    } else {
      wsGetTurnosPacienteDelDiaQr(nextStepTurnosPacienteDelDia)(
        turnosAutoCheckInDispatch
      );
      setBtnGreen(false);
    }
  };
  const handleOnclick = () => {
    if (nextStepTo === "TurnosRecepionados") {
      let nextStepPaso = (isCorrect, data) => {
        if (isCorrect && data) {
          const laboConfirmados = obtenerlaboConfirmados(data);
          const laboNoConfirmados = obtenerlaboNoConfirmados(data);
          const laboPresentes = obtenerlaboPresentes(data);
          data = data.filter((e) => e.presente);
          setTurnosRecepcionadosAll(data)(turnosRecepcionadosDispatch);
          if (laboNoConfirmados.length > 0) {
            const idTipoPuntoControl = 15;
            setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
            setPaso("PuntoControl")(pasoDispatch);
          } else {
            if (laboConfirmados.length > 0) {
              setPaso("SelectorCircuito")(pasoDispatch);
            } else {
              if (laboPresentes.length > 0) {
                setPaso("SelectorCircuito")(pasoDispatch);
              } else {
                setPaso(nextStepTo)(pasoDispatch);
              }
            }
          }
        }
      };
      setLoading("Cargando turnos del día...");
      wsGetTurnosPacienteDelDiaQr(nextStepPaso)(turnosAutoCheckInDispatch);
    } else {
      setPaso(nextStepTo)(pasoDispatch);
      setPasoSelectFamiliar(nextStepTo);
    }
  };

  const handlePortal = (path, paso) => {
    if (autorizado) {
      if (paso) {
        setPaso(path)(pasoDispatch);
      } else {
        history.push(path);
      }
    } else {
      modalPedirClave(path, paso);
    }
  };

  const handlePortalATS = (path, paso) => {
    if (paso) {
      setPaso(path)(pasoDispatch);
    } else {
      history.push(path);
    }
  };

  const navigateTo = (path, paso) => {
    if (paso) {
      setPaso(path)(pasoDispatch);
    } else {
      history.push(path);
    }
  };

  const modalPedirClave = (path, paso) => {
    showModal(
      "Genericos/PedirClave/PedirClave",
      {
        dissmiss: () => dismiss(false),
        dniPaciente: authState.auth.data.paciente.nro_documento,
        navigateTo: () => navigateTo(path, paso),
        obtenerClave: () => modalNewClave(path, paso),
      },
      [],
      "centro",
      true
    )(modalDispatch);
  };

  const modalOrdenesSinAsociar = () => {
    const ordenesLocal = JSON.parse(sessionStorage.getItem("ordenesList"));
    if (ordenesLocal && ordenesLocal.length > 0) {
      showModal(
        "Genericos/OrdenSinAsociar/OrdenSinAsociar",
        {
          dissmiss: () => dismiss(true),
          navigateTo: () => handlePortal("OrdenesDigitales", true),
          pedirClave: () => modalPedirClave("OrdenesDigitales", true),
          autorizado: autorizado,
        },
        [],
        "centro",
        true
      )(modalDispatch);
    }
  };

  const modalNewClave = (path, paso) => {
    dismiss();
    setTimeout(() => {
      showModal(
        "Auth/CambioPassword/CambioPassword",
        {
          texto: "",
          dissmiss: () => dismiss(),
          pathModal: path,
          pasoModal: paso,
          navigateTo: navigateTo,
        },
        [],
        "centro",
        true
      )(modalDispatch);
    }, 10);
  };

  const dismiss = (orden) => {
    hideModal()(modalDispatch);
    if (orden) {
      sessionStorage.setItem("dismissOrden", true);
    }
  };

  const turnosOrdenadosFun = (turnosList) => {
    const turnosOrdenados = OrderTurnosLabo(
      turnosList,
      filtroHorario,
      minutosToleranciaRecepcion,
      minRecepcionVariosTurnos,
      true
    );
    return turnosOrdenados;
  };

  const obtenerlaboConfirmados = (turnosList) => {
    const turnosOrdenados = turnosOrdenadosFun(turnosList);
    const laboConfirmados = turnosOrdenados.filter(
      (turno) =>
        turno.estadoProtocolo > 1 &&
        turno.estadoProtocolo < 4 &&
        turno.type === "laboratorio" &&
        turno.selected
    );
    return laboConfirmados;
  };

  const obtenerlaboNoConfirmados = (turnosList) => {
    const turnosOrdenados = turnosOrdenadosFun(turnosList);
    const laboNoConfirmados = turnosOrdenados.filter(
      (turno) => turno.estadoProtocolo === 1 && turno.type === "laboratorio"
    );
    return laboNoConfirmados;
  };

  const obtenerlaboPresentes = (turnosList) => {
    const turnosOrdenados = turnosOrdenadosFun(turnosList);
    const laboPresentes = turnosOrdenados.filter(
      (turno) => turno.estadoProtocolo === 4 && turno.type === "laboratorio"
    );
    return laboPresentes;
  };

  const nextStepOrdenes = (isCorrect, data) => {
    if (isCorrect) {
      wsGetLabOrdenDigital((isCorrect, dataLabo) =>
        nextStepLabo(isCorrect, data, dataLabo)
      )(labOrdenDigitalDispatch);
    } else {
      showToaster(
        {
          texto: "Error al obtener ordenes digitales.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      setOrdenesLoading(false);
    }
  };

  const nextStepLabo = (isCorrect, data, dataLabo) => {
    if (isCorrect) {
      if (dataLabo.length > 0 || data.length > 0) {
        sessionStorage.setItem("getOrdenes", true);
        let ordenesConcat = [...data, ...dataLabo];
        let ordenesSinAsociar = ordenesConcat.filter(
          (orden) => orden.idturno === -1 || orden.idLabProtAgenda === -1
        );
        let ordenByFecha = ordenesSinAsociar.sort((a, b) => {
          return (
            new Date(b.fechaalta).getTime() - new Date(a.fechaalta).getTime()
          );
        });
        setOrdenesLoading(false);
        sessionStorage.setItem("ordenesList", JSON.stringify(ordenByFecha));
        modalOrdenesSinAsociar();
      } else {
        sessionStorage.setItem("dismissOrden", true);
        setOrdenesLoading(false);
      }
    } else {
      setOrdenesLoading(false);
      showToaster(
        {
          texto: "Error al obtener ordenes de laboratorio.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };
  // // -------------------------  funciones ----------------------------

  // // -------------------------  useEffect ----------------------------
  useEffect(() => {
    let turnoLabo = sessionStorage.getItem("accionLabo");
    if (turnoLabo !== null && turnoLabo !== undefined) {
      sessionStorage.removeItem("accionLabo");
      setPaso("EstudiosLabo")(pasoDispatch);
    } else {
      wsGetTurnosConPresenteQr(nextStepTurnosConPresente)(
        turnosAutoCheckInDispatch
      );
      setTurnosSeleccionado([])(turnosSeleccionadosDispatch);
      LimpiarSelectGlobal()(selectDropDownDispatch);

      // Si entra por primera vez le pregunto si quiere asociar
      // en caso de que haya clickeado que no quiere asociar
      // no vuelvo a hacer el get para no volver a preguntar
      if (noAsociar === undefined || noAsociar === null) {
        wsGetOrdenesDigitalesById(nextStepOrdenes);
      } else {
        setOrdenesLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    if (avisoAutocheckState.avisoAutocheck.show) {
      showModal(
        "Genericos/AvisoAutocheck/AvisoAutocheck",
        { aceptar: aceptarTiempoExtra, disableback: true },
        [],
        "centro",
        true
      )(modalDispatch);
    }
  }, [avisoAutocheckState.avisoAutocheck.show]);

  // // -------------------------  useEffect ----------------------------

  const aceptarTiempoExtra = () => {
    setAvisoAutocheck(false)(avisoAutocheckDispatch);
    hideModal()(modalDispatch);
  };

  return (
    <>
      <Loading
        dataLoading={dataLoading || ordenesLoading}
        color="c-white"
        descripcion={"Cargando..."}
      />
      {dataLoading ? (
        ""
      ) : (
        <Layout origen={"NULL"} positionSidebar={21}>
          <ContianerHome
            initial="hidden"
            animate="show"
            variants={containerVariants}
          >
            <HeaderHomeBar
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{
                duration: 1.5,
                ease: "easeInOut",
                opacity: [0, 0.3, 0.7, 1],
                times: [0, 0.3, 0.7, 1],
              }}
            >
              <span className="title">
                ¡Hola{" "}
                <span className="title-negrita">
                  {pacienteNombre && camelize(pacienteNombre)}
                </span>
                !{" "}
              </span>
              <span className="title-pregunta">
                ¿En que podemos ayudarte{" "}
                <span className="title-negrita">hoy</span>?
              </span>
            </HeaderHomeBar>
            <BtnContainer>
              {btnGreen ? (
                <motion.div variants={itemVariants}>
                  <BtnLink
                    Icon={<TildeOk color={"var(--color-primary)"} />}
                    type={"GREEN"}
                    title={"YA RECEPCIONADOS"}
                    onclick={handleOnclick}
                  />
                </motion.div>
              ) : (
                <motion.div variants={itemVariants}>
                  <BtnLink
                    Icon={<TildeOk color={"var(--color-primary)"} />}
                    type={"NORMAL"}
                    title={"TENGO TURNO"}
                    onclick={handleOnclick}
                  />
                </motion.div>
              )}
              <motion.div variants={itemVariants}>
                <BtnLink
                  Icon={<MiTurnoIcon color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={"NECESITO UN TURNO"}
                  onclick={() => navigateTo("NecesitoTurno", true)}
                />
              </motion.div>
              <motion.div variants={itemVariants}>
                <BtnLink
                  Icon={<FaMapMarkerAlt color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={"ATENCIÓN SIN TURNO"}
                  onclick={() => handlePortalATS("DemandaEspontanea", true)}
                />
              </motion.div>
              <motion.div variants={itemVariants}>
                <BtnLink
                  Icon={<OtrosTramites color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={"ÓRDENES PENDIENTES"}
                  onclick={() => handlePortal("OrdenesDigitales", true)}
                />
              </motion.div>
              <motion.div variants={itemVariants}>
                <BtnLink
                  Icon={<OrdenesDigitalesIcon color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={"PRÓXIMOS TURNOS"}
                  onclick={() => handlePortal("proximosTurnos", false)}
                />
              </motion.div>
            </BtnContainer>

            {portal && portal === "dim" ? (
              <div className="logo-dim">
                <LogoDim height={"550"} />
              </div>
            ) : (
              ""
            )}
          </ContianerHome>
        </Layout>
      )}
    </>
  );
};

export default Home;
